<script lang="ts">
  import OVIcon from "$components/+blocks/OVIcon/OVIcon.svelte";
  import type { IconType } from "$components/+blocks/OVIcon/OVIcon";
  import { getTextColorAndPrimaryVariants } from "app/utils/colors";

  export let textColor: string = "text-white";
  export let fontSize: string = "text-md";
  export let fontWeight: string = "font-medium";
  export let backgroundColor: string = "bg-gray-900/40";
  export let statusColor: "bg-emerald-300" | "bg-pink-400" | "bg-orange-400" | "bg-red-400" | "" =
    "";
  export let customColor: string = "";
  export let statusSize: "w-2" | "w-5" = "w-5";
  export let radius: string = "rounded-[20px]";
  export let horizontalPadding: string = "px-3";
  export let verticalPadding: string = "py-1.5";
  export let lineHeight: "leading-none" | "leading-relaxed" = "leading-relaxed";
  export let border: string = "border-none";
  export let icon: IconType | undefined = undefined;
  export let iconSize = "size-4";

  const colors = getTextColorAndPrimaryVariants(customColor);
</script>

<div
  class="{fontSize} {border} {fontWeight} {lineHeight} {textColor} {horizontalPadding} {verticalPadding} {radius} relative inline-flex h-fit items-center justify-center gap-1 overflow-hidden"
>
  <!--  If the custom color is specified, the overlay gets the custom color specified with an additional low opacity property added.-->
  <!--  Otherwise, the default background color is applied -->
  {#if customColor}
    <div class="{radius} absolute inset-0" style:background-color={customColor} />
  {:else}
    <div class="{backgroundColor} {radius} absolute inset-0" />
  {/if}
  {#if statusColor}
    <span class="{statusSize} {statusColor} relative aspect-square rounded-full" />
  {/if}
  {#if icon}
    <OVIcon {icon} class="relative" size={iconSize} />
  {/if}
  <span
    style:color={customColor ? colors.textColor : null}
    class="relative {fontSize} truncate py-px"
  >
    <slot />
  </span>
</div>
